import { get } from '../../../utils/networking'

export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL"
export const UPDATE_PROFILE_SETVAR = "UPDATE_PROFILE_SETVAR"

export const requestProfileSuccess = (result) => {
    return {
        type: GET_PROFILE_SUCCESS,
        payload: result
    }

}


export const requestProfileFail = () => {
    return {
        type: GET_PROFILE_FAIL
    }
}

export const getProfile = () => {
    return dispatch => {
        get('user/getMyProfile', "customer", result => {
            dispatch(requestProfileSuccess(result.user))
        })
    }
}

export const setVar = (key, value) => {
    return {
        type: UPDATE_PROFILE_SETVAR,
        payload: {
            key,
            value
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/user/setting/action.js